import React, { ReactElement } from 'react';
import Link from 'next/link';
import { useCookies } from 'react-cookie';
import useWindowSize from 'utils/hooks/useWindowSize';
import classNames from 'classnames/bind';
import styles from 'sections/Membership/components/SectionAssociation/SectionAssociation.module.scss';

const cn = classNames.bind(styles);

const SectionAssociation = (): ReactElement => {
  const { width } = useWindowSize();
  const [{ user }] = useCookies(['user']);

  const isNotMember = width !== 0 && (!user || !user?.hash);

  return (
    <section className={cn('association')}>
      <div className={cn('container')}>
        <div className={cn('association__paragraphs')}>
          {isNotMember
            ?
            <p className={cn('association__paragraph')}>
              Either option is the start of your journey with an innovative
              association supported by DP World, a leading enabler of logistics and trade.
              Start your subscription by completing the form via button "Join now".
            </p>
            :
            null
          }
          <p className={cn('association__paragraph')}>
            By signing in or creating an account,
            you agree with our <Link href="/resources/terms-and-conditions">Terms & Conditions</Link> and <Link href="/resources/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionAssociation;